const SDK_TIMEOUT_MS = 10000;
const MAX_ATTEMPTS = 2;

let inflight = null;

export const isNaverMapsReady = () =>
  typeof window !== "undefined" && !!(window.naver && window.naver.maps);

function buildSdkUrl() {
  return `https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${
    process.env.REACT_APP_NCP_CLIENT_ID
  }&v=${Date.now()}`;
}

function load(url, cb, err) {
  var element = document.createElement("script");
  var parent = "body";
  var attr = "src";

  element.async = true;
  element.onload = function () {
    cb();
  };
  element.onerror = function () {
    if (typeof err === "function") {
      err();
    }
  };
  element[attr] = url;
  document[parent].appendChild(element);
}

function loadWithRetry(attempt, onSuccess, onError) {
  const url = buildSdkUrl();
  let settled = false;

  const finishSuccess = () => {
    if (settled) return;
    if (!isNaverMapsReady()) {
      finishFail();
      return;
    }
    settled = true;
    clearTimeout(timer);
    onSuccess();
  };

  const finishFail = () => {
    if (settled) return;
    settled = true;
    clearTimeout(timer);
    if (attempt + 1 < MAX_ATTEMPTS) {
      loadWithRetry(attempt + 1, onSuccess, onError);
      return;
    }
    onError();
  };

  const timer = setTimeout(finishFail, SDK_TIMEOUT_MS);
  load(url, finishSuccess, finishFail);
}

export const initMap = (onSuccess, onError) => {
  const success = typeof onSuccess === "function" ? onSuccess : () => {};
  const fail = typeof onError === "function" ? onError : () => {};

  if (isNaverMapsReady()) {
    success();
    return;
  }

  if (!inflight) {
    inflight = new Promise((resolve, reject) => {
      loadWithRetry(0, resolve, reject);
    }).finally(() => {
      inflight = null;
    });
  }

  inflight.then(success).catch(fail);
};
